<template>
  <b-modal
    id="link-asset-modal"
    ref="modal"
    centered
    size="xl"
    hideHeaderClose
    okTitle="Link"
    content-class="LinkModal"
    :okDisabled="!selectedDevices.length"
    @show="modalShown"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <template #modal-title>
      Linking asset to <code>{{ deviceId }}</code>
    </template>
    <b-form-radio-group v-model="selectedDevices">
      <Table
        class="p-0 text-left"
        :items="items"
        :fields="fields"
        :filterable="true"
        :selectable="true"
        :current-page="currentPage"
        :per-page="perPage"
        :table-options="{ stickyHeader: '400px' }"
        :total-rows="totalRows"
        @sort-changed="onSortChanged"
        @filtered="onFilterChanged"
        @page-changed="onPageChanged"
        @per-page-changed="onPerPageChanged"
      >
        <template v-slot:cell(actions)="data">
          <div class="text-center">
            <b-form-radio :value="data.item.assetId" />
          </div>
        </template>
        <template #empty>
          <h4 class="text-secondary text-center mt-1">
            No device found to link to current asset.
          </h4>
        </template>
      </Table>
    </b-form-radio-group>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    deviceId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: [],
      selectedDevices: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: '',
      sort: null
    };
  },
  computed: {
    ...mapGetters('tenants', ['selectedTenant']),
    tenantId() {
      return _.get(this.selectedTenant, '_id', '');
    },
    fields() {
      return [
        {
          key: 'actions',
          label: 'Select',
          sortable: false
        },
        {
          key: 'assetId',
          label: 'Asset Id',
          sortable: true
        },
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'model',
          label: 'Model',
          sortable: true
        }
      ];
    }
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    modalShown() {
      this.resetModal();
      this.fetchItems();
    },
    selectAsset(v, assetId) {
      if (v && !this.selectedDevices.includes(assetId)) {
        this.selectedDevices.push(deviceId);
      } else if (!v && this.selectedDevices.includes(deviceId)) {
        this.selectedDevices = this.selectedDevices.filter(d => d !== deviceId);
      }
    },
    onPageChanged(page) {
      this.currentPage = page;
      this.fetchItems();
    },
    onPerPageChanged(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.fetchItems();
    },
    onFilterChanged(receivedFilter) {
      this.filter = receivedFilter;
      this.fetchItems();
    },
    onSortChanged(data) {
      this.sort = [
        {
          [data.sortBy]: {
            order: data.sortDesc ? 'desc' : 'asc'
          }
        }
      ];
      this.fetchItems();
    },
    async fetchItems() {
      let query = {
        bool: {
          should: [
            {
              bool: {
                must_not: [
                  {
                    exists: {
                      field: 'deviceId'
                    }
                  }
                ]
              }
            }
          ]
        }
      };
      if (this.filter.length) {
        query.bool.should[0].bool.must = [
          {
            multi_match: {
              query: this.filter,
              type: 'phrase_prefix',
              fields: ['model.text', 'reference.text']
            }
          }
        ];
        query.bool.should.push({
          match: {
            _id: this.filter
          }
        });
      }
      if (this.sort) {
        query.sort = sort;
      }
      try {
        const response = await this.$kuzzle.query({
          index: this.tenantId,
          controller: 'device-manager/asset',
          action: 'search',
          body: {
            query
          },
          from: (this.currentPage - 1) * this.perPage,
          size: this.perPage
        });
        this.items = response.result.hits.map(h => {
          return {
            assetId: h._id,
            reference: h._source.reference,
            model: h._source.model,
            measureTypes: h._source.measures
              ? Object.keys(h._source.measures)
              : []
          };
        });
        this.totalRows = response.result.total;
      } catch (error) {
        this.$log.error(error);
        this.$bvToast.toast(error.message, {
          title: 'Something went wrong while fetching devices',
          noAutoHide: true,
          dismissable: true,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right'
        });
      }
    },
    resetModal() {
      this.selectedDevices = [];
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$emit('confirmLinkAsset', this.selectedDevices, 'link-asset-modal');
    }
  }
};
</script>
